// Facade del motor de reportes sobre el data lake. No tiene adapter mock: si el servicio no
// responde, la pantalla lo dice.
import { analyticsClient } from './analytics.client';

export const analyticsApi = analyticsClient;

export { isAnalyticsConfigured, ReportsServiceNotConfiguredError } from './analytics.client';

export type {
    AnalyticsApi,
    CatalogColumnWire,
    CatalogTablesWire,
    CatalogTableWire,
    ColumnRef,
    FilterOp,
    FilterSpec,
    JobCsvWire,
    MetricFn,
    MetricSpec,
    OrderSpec,
    ReportJobsWire,
    ReportJobStatus,
    ReportJobWire,
    ReportRequest,
    ReportRow,
    RunReportWire,
    TableColumnsWire,
} from './analyticsContract';

export { JOBS_HISTORY_LIMIT } from './analyticsContract';
